import React, { Fragment } from 'react';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { BuildPriceAd } from 'site-modules/shared/components/native-ad/buildprice-ad/buildprice-ad';
import { IncentivesAd } from 'site-modules/shared/components/native-ad/incentives-ad/incentives-ad';
import { getChildren, getContentFreshcoreAd } from 'site-modules/shared/utils/article-helper';

export function renderArticles(articles, isMobile, suppressFirstMedia = false, breakpoint = 'lg') {
  if (!articles.length) {
    return null;
  }

  const isUpMedViewport = ['md', 'sm', 'xs'].includes(breakpoint);

  const contentFreshcoreAd = getContentFreshcoreAd(isMobile);

  return articles.map((article, index) => {
    const isLastArticle = index === articles.length - 1;
    const bnpAdPlacementIndex = articles.length >= 5 ? 4 : articles.length - 1;
    const key = `article-${index}`;

    if (articles.length === 1) {
      article.content.splice(contentFreshcoreAd.entry, 0, contentFreshcoreAd);
    }

    return (
      <div className="article" key={key}>
        <ScrollElement id={`scrollTop-related-${key + 1}`} />

        <Fragment>{getChildren({ article, key, suppressMedia: !index && suppressFirstMedia })}</Fragment>

        {index === 0 && isUpMedViewport && (
          <Fragment>
            <hr className="my-1_5" />
            <IncentivesAd mobile={isMobile} wrapperClass="mb-2 px-0" />
          </Fragment>
        )}
        {index === bnpAdPlacementIndex && isUpMedViewport && (
          <Fragment>
            <hr className="my-1_5" />
            <BuildPriceAd mobile={isMobile} wrapperClass="d-flex justify-content-center" />
          </Fragment>
        )}
        {!isLastArticle && <hr className="mt-1_5 mb-2" />}
      </div>
    );
  });
}
